// extracted by mini-css-extract-plugin
module.exports = {"overlay":"OverlayContainer_overlay__2ueMV","overlayNoBackground":"OverlayContainer_overlayNoBackground__1w-kN","container":"OverlayContainer_container__1N_zM"};